import { stringify } from 'querystring';
import { ceV2Axios } from './axios';
import { DataResponse, Invoice } from '../models';
import { RequestErrorPolicy } from './error-presentation';

export const getInvoices = async (
  invoiceRequest: Required<{ invoiceNumbers: string[] }>,
  errorPolicy: RequestErrorPolicy = {},
) => (await ceV2Axios.get<DataResponse<Invoice[]>>('/invoices', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: {
    invoice_number: invoiceRequest.invoiceNumbers,
  },
  paramsSerializer: {
    serialize: params => stringify(params),
  },
  data: {},
  ...errorPolicy,
})).data.data;
